import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
    Avatar, Modal, Input, Icon, Spin,
} from 'antd';
import { history } from '../../../../../../config/history';
import { addNoteRequest } from '../../../redux/actions/add_note.actions';
import { updateBlemishReportRequest } from '../../../redux/actions/questions_actions/update_blemish_report.actions';
import { getLeadProfilePhotosRequest } from '../../../redux/actions/lead_profile_photos.actions';
import { editableStatus, questionsStepsMapper } from '../constants';
import BlemishReportVersion4 from './BlemishReportVersion4';
import { setLeadValuationRequest } from '../../../redux/actions/set_lead_valuation.actions';
import BlemishIcon from '../../Lead_profile_table/components/BlemishIcon';

const blemish_report_result_styles = {
    heading: {
        fontSize: 16,
        backgroundColor: '#f7fdff',
        paddingLeft: 20,
        marginBottom: 10,
        borderTopRightRadius: 5,
        borderBottomRightRadius: 5,
    },
};

/*
Step 1
2
3
4
47
57
23
24

Step 2
5
7
29
33
34
35
36
38
39
44

Step 3
12
21
31
20
37
25
40
41
42
30
27
28
16
58
19
17
26
32

Step 4
49
43
45
46
 */


class BlemishReportResultTab extends Component {
    constructor(props) {
        super(props);
        this.closeModal = this.closeModal.bind(this);
    }

    lead_id = this.props.lead_id || history.location.pathname.slice(-24);

    state = {
        imageModalVisible: false,
        photo_address: '',
        blemishEditStep: null,
        questionNumber: 0,
        isEdit: !!editableStatus[this.props.currentStatus],
    };

    componentDidUpdate(prevProps) {
        const { currentStatus } = this.props;

        if (prevProps.currentStatus !== currentStatus) {
            this.setState({ isEdit: !!editableStatus[currentStatus] });
        }
    }

    showImageModal = (event) => this.setState({ photo_address: event.target.src, imageModalVisible: true });

    closeImageModal = () => this.setState({ imageModalVisible: false });

    blemishReportStatus = (blemish_report) => {
        let currentStatus = null;
        if (blemish_report.ref_lead_blemish_report_status === '5c6bb312b8292a22d8128dfb') {
            currentStatus = 'Pending';
        } else if (blemish_report.ref_lead_blemish_report_status === '5c6bb355b8292a22d8128dfc') {
            currentStatus = 'In Progress';
        } else if (blemish_report.ref_lead_blemish_report_status === '5c6bb37fb8292a22d8128dfe') {
            currentStatus = 'Complete';
        } else if (blemish_report.ref_lead_blemish_report_status === '5c6bb394b8292a22d8128dff') {
            currentStatus = 'Failed';
        }

        return currentStatus;
    };

    showNote = (customer_note, note) => {
        if (customer_note && note) {
            return (
                <>
                    <span className="blemishText">{customer_note}</span>
                    <span>|</span>
                    <span className="blemishText">{note}</span>
                </>
            );
        }

        return (<span className="blemishText">{note || customer_note}</span>);
    }

    blemishReportQuestionsResult = (questions) => {
        const blemish_report_status = this.props.blemish_report && this.blemishReportStatus(this.props.blemish_report);

        let content = [];
        content.push(
            <div className="blemish-row-container" key={0}>
                <div className="blemish-row">
                    <span>&nbsp;</span>
                    <div className="blemish-row_answer-container">
                        <span className="noSet">Cus.</span>
                        <span className="noSet">Age.</span>
                    </div>
                </div>
            </div>,
        );

        if (this.props.step === 'step-1' && blemish_report_status === 'Pending') {
            content = this.createBlemishContent(content, 2, questions);
            content = this.createBlemishContent(content, 3, questions);
            content = this.createBlemishContent(content, 4, questions);
            content = this.createBlemishContent(content, 47, questions);
            content = this.createBlemishContent(content, 57, questions);
            content = this.createBlemishContent(content, 23, questions);
            content = this.createBlemishContent(content, 24, questions);
        } else if (this.props.step === 'step-2' && blemish_report_status === 'Pending') {
            content = this.createBlemishContent(content, 2, questions);
            content = this.createBlemishContent(content, 3, questions);
            content = this.createBlemishContent(content, 4, questions);
            content = this.createBlemishContent(content, 47, questions);
            content = this.createBlemishContent(content, 57, questions);
            content = this.createBlemishContent(content, 23, questions);
            content = this.createBlemishContent(content, 24, questions);

            content = this.createBlemishContent(content, 5, questions);
            content = this.createBlemishContent(content, 7, questions);
            content = this.createBlemishContent(content, 29, questions);
            content = this.createBlemishContent(content, 33, questions);
            content = this.createBlemishContent(content, 34, questions);
            content = this.createBlemishContent(content, 35, questions);
            content = this.createBlemishContent(content, 36, questions);
            content = this.createBlemishContent(content, 38, questions);
            content = this.createBlemishContent(content, 39, questions);
            content = this.createBlemishContent(content, 44, questions);
        } else if (this.props.step === 'step-3' && blemish_report_status === 'Pending') {
            content = this.createBlemishContent(content, 2, questions);
            content = this.createBlemishContent(content, 3, questions);
            content = this.createBlemishContent(content, 4, questions);
            content = this.createBlemishContent(content, 47, questions);
            content = this.createBlemishContent(content, 57, questions);
            content = this.createBlemishContent(content, 23, questions);
            content = this.createBlemishContent(content, 24, questions);

            content = this.createBlemishContent(content, 5, questions);
            content = this.createBlemishContent(content, 7, questions);
            content = this.createBlemishContent(content, 29, questions);
            content = this.createBlemishContent(content, 33, questions);
            content = this.createBlemishContent(content, 34, questions);
            content = this.createBlemishContent(content, 35, questions);
            content = this.createBlemishContent(content, 36, questions);
            content = this.createBlemishContent(content, 38, questions);
            content = this.createBlemishContent(content, 39, questions);
            content = this.createBlemishContent(content, 44, questions);

            content = this.createBlemishContent(content, 12, questions);
            content = this.createBlemishContent(content, 21, questions);
            content = this.createBlemishContent(content, 31, questions);
            content = this.createBlemishContent(content, 20, questions);
            content = this.createBlemishContent(content, 37, questions);
            content = this.createBlemishContent(content, 25, questions);
            content = this.createBlemishContent(content, 40, questions);
            content = this.createBlemishContent(content, 41, questions);
            content = this.createBlemishContent(content, 42, questions);
            content = this.createBlemishContent(content, 30, questions);
            content = this.createBlemishContent(content, 27, questions);
            content = this.createBlemishContent(content, 28, questions);
            content = this.createBlemishContent(content, 16, questions);
            content = this.createBlemishContent(content, 58, questions);
            content = this.createBlemishContent(content, 19, questions);
            content = this.createBlemishContent(content, 17, questions);
            content = this.createBlemishContent(content, 26, questions);
            content = this.createBlemishContent(content, 32, questions);
        } else {
            for (let index = 1; index <= Object.keys(questions).length - 1; index++) {
                if (questions[`question_${index}`] && questions[`question_${index}`].question_for && !questions[`question_${index}`].question_for.includes('Agent')) {
                    continue;
                }

                content = this.createBlemishContent(content, index, questions);
            }
        }


        return content;
    };

    returnColour(value, id, question) {
        if (value !== null && value !== undefined) {
            switch (id) {
            case 'question_2':
            case 'question_4':
            case 'question_6':
            case 'question_10':
            case 'question_15':
            case 'question_16':
            case 'question_17':
            case 'question_18':
            case 'question_19':
            case 'question_21':
            case 'question_23':
            case 'question_38':
            case 'question_48':
            case 'question_49':
            case 'question_57':
                return value ? 'pass' : 'potential';
            case 'question_3':
            case 'question_5':
            case 'question_7':
            case 'question_12':
            case 'question_20':
            case 'question_25':
            case 'question_26':
            case 'question_27':
            case 'question_28':
            case 'question_29':
            case 'question_30':
            case 'question_31':
            case 'question_32':
            case 'question_33':
            case 'question_34':
            case 'question_35':
            case 'question_36':
            case 'question_37':
            case 'question_39':
            case 'question_40':
            case 'question_41':
            case 'question_42':
            case 'question_44':
            case 'question_47':
                return !value ? 'pass' : 'potential';
            // case 'question_6':
            //     return value ? 'pass' : 'fail';
            default:
                return 'noSet'; // fail, noSet
            }
        } else {
            return 'noSet';
        }
    }

    handleShowEditBlemishReportModal = (step) => {
        this.setState({ blemishEditStep: step });
    }

    createBlemishContent(content, index, questions) {
        const blemishReportStep = questionsStepsMapper[index];
        const { isEdit } = this.state;

        if (index === 10) {
            content.push(
                <div className="blemish-row-container" key={questions[`question_${index}`]._id}>
                    <div className="blemish-row">
                        <span>Are you buying another bike?</span>

                        <div className="blemish-row_photos-container">
                            {
                                this.props.photos.map(
                                    (photo) => {
                                        if (photo.blemish_report_question && (questions[`question_${index}`].title === photo.blemish_report_question)) {
                                            return <Avatar key={index} size="small" className="border-shadows pointer" onClick={this.showImageModal} src={photo.picture} shape="square" />;
                                        }

                                        return null;
                                    },
                                )
                            }
                        </div>

                        <div className="blemish-row_answer-container">
                            <span className="blemishText">{questions[`question_${index}`].note}</span>

                            <span className="blemishText">{questions[`question_${index}`].technician_note}</span>


                            <span className={this.returnColour(questions[`question_${index}`].customer_value, `question_${index}`, 'Are you buying another bike?')}>
                                {

                                    questions[`question_${index}`].customer_value === true
                                        ? 'Yes'
                                        : questions[`question_${index}`].customer_value === false ? 'No' : '-'
                                }
                            </span>


                            <span className={this.returnColour(questions[`question_${index}`].value, `question_${index}`, 'Are you buying another bike?')}>
                                {
                                    questions[`question_${index}`].value === true
                                        ? 'Yes'
                                        : questions[`question_${index}`].value === false ? 'No' : '-'
                                }
                            </span>

                            {!!blemishReportStep && isEdit && <span className="blemish-row-edit" onClick={() => this.handleShowEditBlemishReportModal(blemishReportStep)}><Icon type="edit" /></span>}
                        </div>
                    </div>
                </div>,
            );
        } else if (questions[`question_${index}`] && questions[`question_${index}`].we_wont_buy) {
            content.push(
                <div className="blemish-row-container" key={questions[`question_${index}`]._id}>
                    <div className="blemish-row">
                        <span>{questions[`question_${index}`].title}</span>
                        <div className="blemish-row_photos-container">
                            {
                                this.props.photos.map(
                                    (photo) => {
                                        if (photo.blemish_report_question && (questions[`question_${index}`].title === photo.blemish_report_question)) {
                                            return <Avatar key={index} size="small" className="border-shadows pointer" onClick={this.showImageModal} src={photo.picture} shape="square" />;
                                        }

                                        return null;
                                    },
                                )
                            }
                        </div>

                        <div className="blemish-row_answer-container">
                            <span className="blemishText">{questions[`question_${index}`].note}</span>

                            <span className="blemishText">{questions[`question_${index}`].technician_note}</span>


                            <span className={this.returnColour(questions[`question_${index}`].customer_value, `question_${index}`, questions[`question_${index}`].title)}>
                                {' '}
                                {
                                    questions[`question_${index}`].customer_value === true
                                        ? 'Yes'
                                        : questions[`question_${index}`].customer_value === false ? 'No' : '-'
                                }
                            </span>


                            <span className={this.returnColour(questions[`question_${index}`].value, `question_${index}`, questions[`question_${index}`].title)}>
                                {
                                    questions[`question_${index}`].value === true
                                        ? 'Yes'
                                        : questions[`question_${index}`].value === false ? 'No' : '-'
                                }
                            </span>

                            {!!blemishReportStep && isEdit && <span className="blemish-row-edit" onClick={() => this.handleShowEditBlemishReportModal(blemishReportStep)}><Icon type="edit" /></span>}
                        </div>
                    </div>
                </div>,
            );
        } else if (questions[`question_${index}`] && questions[`question_${index}`].price_adjustment_required) {
            content.push(
                <div className="blemish-row-container" key={questions[`question_${index}`]._id}>
                    <div className="blemish-row">
                        <span>{questions[`question_${index}`].title}</span>

                        <div className="blemish-row_photos-container">
                            {
                                this.props.photos.map(
                                    (photo) => {
                                        if (photo.blemish_report_question && (questions[`question_${index}`].title === photo.blemish_report_question)) {
                                            return <Avatar key={index} size="small" className="border-shadows pointer" onClick={this.showImageModal} src={photo.picture} shape="square" />;
                                        }

                                        return null;
                                    },
                                )
                            }
                        </div>

                        <div className="blemish-row_answer-container">
                            <span className="blemishText">{questions[`question_${index}`].note}</span>
                            <span className="blemishText">{questions[`question_${index}`].technician_note}</span>


                            <span className={this.returnColour(questions[`question_${index}`].customer_value, `question_${index}`, questions[`question_${index}`].title)}>
                                {' '}
                                {
                                    questions[`question_${index}`].customer_value === true
                                        ? 'Yes'
                                        : questions[`question_${index}`].customer_value === false ? 'No' : '-'
                                }
                            </span>

                            <span className={this.returnColour(questions[`question_${index}`].value, `question_${index}`, questions[`question_${index}`].title)}>
                                {
                                    questions[`question_${index}`].value === true
                                        ? 'Yes'
                                        : questions[`question_${index}`].value === false ? 'No' : '-'
                                }
                            </span>

                            {!!blemishReportStep && isEdit && <span className="blemish-row-edit" onClick={() => this.handleShowEditBlemishReportModal(blemishReportStep)}><Icon type="edit" /></span>}
                        </div>
                    </div>
                </div>,
            );
        } else if (questions[`question_${index}`] && questions[`question_${index}`].additional_photos_required) {
            content.push(
                <div className="blemish-row-container" key={questions[`question_${index}`]._id}>
                    <div className="blemish-row">
                        <span>{questions[`question_${index}`].title}</span>

                        <div className="blemish-row_photos-container">
                            {
                                this.props.photos.map(
                                    (photo) => {
                                        if (photo.blemish_report_question && (questions[`question_${index}`].title === photo.blemish_report_question)) {
                                            return <Avatar key={index} size="small" className="border-shadows pointer" onClick={this.showImageModal} src={photo.picture} shape="square" />;
                                        }

                                        return null;
                                    },
                                )
                            }
                        </div>

                        <div className="blemish-row_answer-container">
                            <span className="blemishText">{questions[`question_${index}`].note}</span>
                            <span className="blemishText">{questions[`question_${index}`].technician_note}</span>


                            <span className={this.returnColour(questions[`question_${index}`].customer_value, `question_${index}`, questions[`question_${index}`].title)}>
                                {' '}
                                {
                                    questions[`question_${index}`].customer_value === true
                                        ? 'Yes'
                                        : questions[`question_${index}`].customer_value === false ? 'No' : '-'
                                }
                            </span>

                            <span className={this.returnColour(questions[`question_${index}`].value, `question_${index}`, questions[`question_${index}`].title)}>
                                {
                                    questions[`question_${index}`].value === true
                                        ? 'Yes'
                                        : questions[`question_${index}`].value === false ? 'No' : '-'
                                }
                            </span>

                            {!!blemishReportStep && isEdit && <span className="blemish-row-edit" onClick={() => this.handleShowEditBlemishReportModal(blemishReportStep)}><Icon type="edit" /></span>}
                        </div>
                    </div>
                </div>,
            );
        } else if (questions[`question_${index}`] && questions[`question_${index}`].category !== 1 && questions[`question_${index}`].category !== 3) {
            if (questions[`question_${index}`].category === 7) {
                content.push(
                    <div className="blemish-row-container" key={questions[`question_${index}`]._id}>
                        <div className="blemish-row">
                            <span>{questions[`question_${index}`].title}</span>

                            <div className="blemish-row_photos-container">
                                {
                                    this.props.photos.map(
                                        (photo) => {
                                            if (photo.blemish_report_question && (questions[`question_${index}`].title === photo.blemish_report_question)) {
                                                return <Avatar key={index} size="small" className="border-shadows pointer" onClick={this.showImageModal} src={photo.picture} shape="square" />;
                                            }

                                            return null;
                                        },
                                    )
                                }
                            </div>

                            <div className="blemish-row_answer-container">
                                <span className="blemishText">{questions[`question_${index}`].note}</span>
                                <span className="blemishText">{questions[`question_${index}`].technician_note}</span>


                                <span className={this.returnColour(questions[`question_${index}`].customer_value, `question_${index}`, questions[`question_${index}`].title)}>
                                    {' '}
                                    {
                                        questions[`question_${index}`].customer_value === true
                                            ? 'Yes'
                                            : questions[`question_${index}`].customer_value === false ? 'No' : '-'
                                    }
                                </span>

                                <span className={this.returnColour(questions[`question_${index}`].value, `question_${index}`, questions[`question_${index}`].title)}>
                                    {
                                        questions[`question_${index}`].value === true
                                            ? 'Yes'
                                            : questions[`question_${index}`].value === false ? 'No' : '-'
                                    }
                                </span>

                                {!!blemishReportStep && isEdit && <span className="blemish-row-edit" onClick={() => this.handleShowEditBlemishReportModal(blemishReportStep)}><Icon type="edit" /></span>}
                            </div>
                        </div>
                    </div>,
                );
            } else if (questions[`question_${index}`] && questions[`question_${index}`].category !== 2) {
                content.push(
                    <div className="blemish-row-container" key={questions[`question_${index}`]._id}>
                        <div className="blemish-row">
                            <span>{questions[`question_${index}`].title}</span>

                            <div className="blemish-row_photos-container">
                                {
                                    this.props.photos.map(
                                        (photo) => {
                                            if (photo.blemish_report_question && (questions[`question_${index}`].title === photo.blemish_report_question)) {
                                                return <Avatar key={index} size="small" className="border-shadows pointer" onClick={this.showImageModal} src={photo.picture} shape="square" />;
                                            }

                                            return null;
                                        },
                                    )
                                }
                            </div>

                            <div className="blemish-row_answer-container">
                                {this.showNote(questions[`question_${index}`].customer_note, questions[`question_${index}`].note)}

                                <span className="blemishText">{questions[`question_${index}`].technician_note}</span>


                                <span className={this.returnColour(questions[`question_${index}`].customer_value, `question_${index}`, questions[`question_${index}`].title)}>
                                    {' '}
                                    {
                                        questions[`question_${index}`].customer_value === true
                                            ? 'Yes'
                                            : questions[`question_${index}`].customer_value === false ? 'No' : '-'
                                    }
                                </span>


                                <span className={this.returnColour(questions[`question_${index}`].value, `question_${index}`, questions[`question_${index}`].title)}>
                                    {' '}
                                    {
                                        questions[`question_${index}`].value === true
                                            ? 'Yes'
                                            : questions[`question_${index}`].value === false ? 'No' : '-'
                                    }
                                </span>

                                {!!blemishReportStep && isEdit && <span className="blemish-row-edit" onClick={() => this.handleShowEditBlemishReportModal(blemishReportStep)}><Icon type="edit" /></span>}
                            </div>
                        </div>
                    </div>,
                );
            } else {
                content.push(
                    <div className="blemish-row-container" key={questions[`question_${index}`]._id}>
                        <div className="blemish-row">
                            <span>{questions[`question_${index}`].title}</span>

                            <div className="blemish-row_photos-container">
                                {
                                    this.props.photos.map((photo) => {
                                        if (photo.blemish_report_question && (questions[`question_${index}`].title === photo.blemish_report_question)) {
                                            return <Avatar key={index} size="small" className="border-shadows pointer" onClick={this.showImageModal} src={photo.picture} shape="square" />;
                                        }

                                        return null;
                                    })
                                }
                            </div>

                            <div className="blemish-row_answer-container">
                                <span className="blemishText">{questions[`question_${index}`].note}</span>

                                <span className="blemishText">{questions[`question_${index}`].driver_note}</span>

                                <span className={this.returnColour(questions[`question_${index}`].customer_value, `question_${index}`, questions[`question_${index}`].title)}>
                                    {
                                        questions[`question_${index}`].customer_value === true
                                            ? 'Yes'
                                            : questions[`question_${index}`].customer_value === false ? 'No' : '-'
                                    }
                                </span>


                                <span className={this.returnColour(questions[`question_${index}`].value, `question_${index}`, questions[`question_${index}`].title)}>
                                    {' '}
                                    {
                                        questions[`question_${index}`].value === true
                                            ? 'Yes'
                                            : questions[`question_${index}`].value === false ? 'No' : '-'
                                    }
                                </span>

                                {!!blemishReportStep && isEdit && <span className="blemish-row-edit" onClick={() => this.handleShowEditBlemishReportModal(blemishReportStep)}><Icon type="edit" /></span>}
                            </div>
                        </div>
                    </div>,
                );
            }
        } else if (questions[`question_${index}`] && questions[`question_${index}`].category === 3) {
            content.push(
                <div className="blemish-row-container" key={questions[`question_${index}`]._id}>
                    <div className="blemish-row">
                        <span>{questions[`question_${index}`].title}</span>
                        <div className="blemish-row_photos-container">
                            {
                                this.props.photos.map(
                                    (photo) => {
                                        if (photo.blemish_report_question && (questions[`question_${index}`].title === photo.blemish_report_question)) {
                                            return <Avatar size="small" className="border-shadows pointer" onClick={this.showImageModal} src={photo.picture} shape="square" />;
                                        }
                                        return null;
                                    },
                                )
                            }
                        </div>
                        <div className="blemish-row_answer-container">
                            {this.showNote(questions[`question_${index}`].customer_note, questions[`question_${index}`].note)}

                            <span className="blemishText">{questions[`question_${index}`].technician_note}</span>
                        </div>
                        {!!blemishReportStep && isEdit && <span className="blemish-row-edit" onClick={() => this.handleShowEditBlemishReportModal(blemishReportStep)}><Icon type="edit" /></span>}
                    </div>
                </div>,
            );
        }

        return content;
    }

    closeModal() {
        this.setState({ blemishEditStep: null });
    }

    getModalTitle() {
        return (
            <>
                <BlemishIcon isBlemishModal={true} />{' '}
                Edit Blemish Report
            </>
        );
    }

    render() {
        const { blemishEditStep, isEdit } = this.state;
        const blemish_report_status = this.props.blemish_report && this.blemishReportStatus(this.props.blemish_report);

        const questions = this.props.blemish_report ? this.props.blemish_report.questions : null;

        return (
            <Spin tip="Saving answer..." spinning={this.props.blemish_report_loading}>
                {blemishEditStep && (
                    <Modal
                        visible
                        onCancel={this.closeModal}
                        footer={null}
                        maskClosable={false}
                        width={680}
                        title={this.getModalTitle()}
                    >
                        <BlemishReportVersion4 closeModal={this.closeModal} blemishEditStep={blemishEditStep} />
                    </Modal>
                )}

                {this.props.blemish_report
                    ? (
                        <div>
                            <h3
                                style={blemish_report_result_styles.heading}
                            >
                                Blemish Report
                                <span
                                    className="approval_status"
                                    style={
                                        (blemish_report_status === 'Failed')
                                            ? { backgroundColor: '#cc0000' }
                                            : (blemish_report_status === 'Complete')
                                                ? { backgroundColor: 'green' }
                                                : {}}
                                >
                                    {blemish_report_status}
                                </span>
                            </h3>

                            <div className="blemishWrapper">

                                {
                                    (blemish_report_status === 'Pending')
                                        ? (
                                            <Fragment>
                                                <h5>Blemish report hasn't been completed yet</h5>
                                            </Fragment>
                                        )
                                        : (blemish_report_status === 'In Progress')
                                            ? (
                                                <Fragment>
                                                    <h5>Blemish report currently in progress</h5>
                                                    <div>
                                                        {this.blemishReportQuestionsResult(questions)}
                                                    </div>
                                                </Fragment>
                                            )
                                            : (
                                                <Fragment>
                                                    <div>
                                                        {this.blemishReportQuestionsResult(questions)}
                                                    </div>
                                                </Fragment>
                                            )
                                }
                                <Modal
                                    visible={this.state.imageModalVisible}
                                    footer={null}
                                    onCancel={this.closeImageModal}
                                >
                                    <img style={{ width: '100%', marginTop: '5%' }} src={this.state.photo_address} alt="bike_photo" />
                                </Modal>
                                <Modal
                                    visible={this.state.chipModalVisible}
                                    width={220}
                                    title="Chip Value"
                                    okText="Submit"
                                    cancelText="Go Back"
                                    onOk={this.saveChip}
                                    onCancel={this.closeChipModal}
                                    okButtonProps={{ disabled: !isEdit }}
                                >
                                    <Input
                                        disabled={!isEdit}
                                        type="number"
                                        value={this.state.chipValue}
                                        size="small"
                                        prefix="£"
                                        onChange={(event) => this.handleChipChange(event.target.value)}
                                    />
                                </Modal>
                            </div>
                        </div>
                    )
                    : (
                        <div style={{ marginLeft: 20, marginRight: 20 }} className="blemishWrapper">
                            <h5>Blemish report hasn't been completed yet</h5>
                        </div>
                    )
                }
            </Spin>
        );
    }
}

const mapStateToProps = (state) => ({
    blemish_report: state.Leads.Lead_profile.Lead_blemish_report.blemish_report,
    photos: state.Leads.Lead_profile.Lead_photos.photos,
    user: state.App.App_content.user,
    lead_id: state.Leads.Lead_profile.Lead_general.root_id,
    valuations: state.Leads.Lead_profile.Lead_valuations,
    currentStatus: state.Leads.Lead_profile.Lead_general.current_status._id,
    blemish_report_loading: state.Leads.Lead_profile.Lead_blemish_report.blemish_report_loading,
});

export default connect(
    mapStateToProps,
    {
        updateBlemishReportRequest,
        addNoteRequest,
        getLeadProfilePhotosRequest,
        setLeadValuationRequest,
    },
)(BlemishReportResultTab);

/*


 */



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/components/Lead_profile_blemish_report/components/BlemishReportResultTab.js